/**
 * H5 应用配置（改这里即可；修改后需重新编译或刷新 dev 服务）
 */

/**
 * 热点调试可视：true 时所有可点击热点显示半透明粉红底 + 虚线边框，便于开发对齐位置。
 * 生产环境务必保持 false。
 */
export const HOTSPOT_DEBUG_VISIBLE = false

/** 全 H5 API 环境（唯一开关）：local 本地 | production 生产 */
export const H5_API_ENV = 'production'
// export const H5_API_ENV = 'production'

/** 本地 crm-app 直连（末尾不要 /） */
export const H5_LOCAL_API_BASE = 'http://192.168.3.3:8223/app'

/** 生产 crm-app 地址 */
export const H5_PRODUCTION_API_BASE = 'https://wvxvb.cn/app'

/** devServer / 局域网调试走 /app 代理（与 vue.config.js proxy 一致） */
export function isH5DevProxyHost(hostname) {
  if (!hostname) return false
  if (hostname === 'localhost' || hostname === '127.0.0.1') return true
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true
  if (/^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true
  return false
}

/** @deprecated 兼容旧名 */
export const isCarvueDevProxyHost = isH5DevProxyHost

function trimApiBase(url) {
  return url != null ? String(url).replace(/\/$/, '') : ''
}

/** 解析 crm-app API 根路径 */
export function resolveH5AppApiBase() {
  if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_API_BASE) {
    return trimApiBase(process.env.VUE_APP_API_BASE)
  }
  const hostname = typeof window !== 'undefined' && window.location ? window.location.hostname : ''
  if (H5_API_ENV === 'local') {
    const isDevBuild = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development'
    if (isDevBuild || isH5DevProxyHost(hostname)) return '/app'
    return trimApiBase(H5_LOCAL_API_BASE)
  }
  return trimApiBase(H5_PRODUCTION_API_BASE)
}

export const APP_API_BASE = resolveH5AppApiBase()
export const SIGNSTORE_APP_BASE = APP_API_BASE
